import { IUserPermissions } from "redux/reducers/models/user";
import { TReportAdminScope } from "./reportCatalog.types";

function getReportPermissionValue(
  permissions: IUserPermissions | Record<string, unknown>,
  code: string,
  scope: TReportAdminScope,
): unknown {
  void scope;
  const permissionKey = `reports_facility_${code.replace(/-/g, "_")}`;
  return permissions[permissionKey as keyof typeof permissions];
}

export function hasSpecificReportPermission(
  permissions: IUserPermissions | Record<string, unknown> | undefined,
  code: string,
  scope: TReportAdminScope,
): boolean {
  if (!permissions) {
    return false;
  }

  const value = getReportPermissionValue(permissions, code, scope);

  return value == true || value == null;
}

export function hasReportPermission(
  permissions: IUserPermissions | Record<string, unknown> | undefined,
  code: string,
  scope: TReportAdminScope,
): boolean {
  if (!permissions) {
    return false;
  }

  if (permissions.reports_access !== true) {
    return false;
  }

  const value = getReportPermissionValue(permissions, code, scope);

  return value == true || value == null;
}

export function isClientScopedReportVisible(
  apiReport: { client_id?: number | string | null },
  userClientId: number | undefined,
  permissions: IUserPermissions | Record<string, unknown> | undefined,
  code: string,
  scope: TReportAdminScope,
): boolean {
  if (apiReport.client_id == null) {
    return true;
  }

  if (userClientId == null || Number(apiReport.client_id) !== Number(userClientId)) {
    return false;
  }

  return hasReportPermission(permissions, code, scope);
}
